import React from 'react';
import ReactDOM from 'react-dom';
import {HeaderImageApp} from "./apps/HeaderImageApp";


let headerImages = document.getElementsByClassName('homeHeaderImage');

[].forEach.call(headerImages, function(headerImage){
	const headerVariants = JSON.parse(headerImage.getAttribute('data-headervariant-data'));
	const breakingNews = headerImage.getAttribute('data-breakingnews-data');
	const breakingNewsMobile = headerImage.getAttribute('data-breakingnewsmobile-data');
	const breakingNewsType = headerImage.getAttribute('data-breakingnewstype-data');


	ReactDOM.render(
		<HeaderImageApp headerVariants={headerVariants} breakingNews={breakingNews} breakingNewsMobile={breakingNewsMobile} breakingNewsType={breakingNewsType} />,
        headerImage
	);
});



// WEBPACK FOOTER //
// ./src/headerImage.js